var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalReferralsIconIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chain_10408189",
    d: "M2,13.4A11.4,11.4,0,0,1,13.4,2H28.6A11.4,11.4,0,0,1,40,13.4V28.6A11.4,11.4,0,0,1,28.6,40H13.4A11.4,11.4,0,0,1,2,28.6Zm19.35-.656a5.8,5.8,0,0,1,6.381-.523A5.49,5.49,0,0,1,29.7,19.859l-1.778,3.005a5.845,5.845,0,0,1-7.837,2.176,5.437,5.437,0,0,1-2.7-5.592,1.267,1.267,0,1,0-2.5-.384,7.97,7.97,0,0,0,3.965,8.183A8.378,8.378,0,0,0,30.1,24.155L31.88,21.15a8.023,8.023,0,0,0-2.9-11.135,8.332,8.332,0,0,0-9.178.729,1.267,1.267,0,0,0,1.554,2Zm1.809,2.008A8.378,8.378,0,0,0,11.9,17.845L10.12,20.85a8.023,8.023,0,0,0,2.9,11.135,8.332,8.332,0,0,0,9.178-.729,1.267,1.267,0,1,0-1.554-2,5.8,5.8,0,0,1-6.381.523A5.49,5.49,0,0,1,12.3,22.141l1.778-3.005a5.845,5.845,0,0,1,7.837-2.176,5.437,5.437,0,0,1,2.7,5.592,1.267,1.267,0,1,0,2.5.384,7.97,7.97,0,0,0-3.965-8.183Z",
    transform: "translate(-2 -2)",
    fill: "#3dfc36",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalReferralsIconIcon);
export default __webpack_public_path__ + "static/media/total_referralsIcon_icon.3c15f3bda3d5f86c1edc8f8c245d78ed.svg";
export { ForwardRef as ReactComponent };